import { IApiLink, IMultipleEntitiesResponse } from "@/types"
import CostCategory, { IGetCostCategoryDto } from "./CostCategory"
import { ApiLinkEntity, ApiLinkRel } from "config/constants"

export interface IGetCostCategoriesDto extends IMultipleEntitiesResponse<IGetCostCategoryDto> {}

export default class CostCategories {
    list: CostCategory[]
    linkGet?: IApiLink
    linkCreate?: IApiLink

    constructor({
        entities,
        links,
    }: IGetCostCategoriesDto) {
        this.list = entities.map(dto => new CostCategory(dto))
        this.linkGet = links?.find(lnk => lnk.entity === ApiLinkEntity.invoiceCostCategory && lnk.rel === ApiLinkRel.all)
        this.linkCreate = links?.find(lnk => lnk.entity === ApiLinkEntity.invoiceCostCategory && lnk.rel === ApiLinkRel.new)
    }

    get canCreate(): boolean {
        return !!this.linkCreate
    }
}
